(() => {
  'use strict';

  const viewportClass = () => {
    if (window.innerWidth < 750) return 'mobile';
    if (window.innerWidth < 990) return 'tablet';
    return 'desktop';
  };

  const safeMetadata = (panel) => ({
    product_id: panel.dataset.productId || '',
    variant_id: panel.dataset.variantId || '',
    product_handle: panel.dataset.productHandle || '',
    product_role: panel.dataset.productRole || '',
    stamp_brand: panel.dataset.stampBrand || '',
    personaliser_type: 'zepto',
    viewport_class: viewportClass(),
    event_version: '1',
  });

  const track = (name, metadata) => window.AtlasAnalytics?.track?.(name, metadata);

  const init = () => {
    document.querySelectorAll('[data-atlas-personalisation-confidence]').forEach((panel) => {
      if (panel.dataset.analyticsReady === 'true') return;
      panel.dataset.analyticsReady = 'true';
      const metadata = safeMetadata(panel);
      track('atlas_personalisation_confidence_view', metadata);
      panel.querySelector('[data-atlas-personalisation-help]')?.addEventListener('click', () => {
        track('atlas_personalisation_help_click', metadata);
      });
      const scope = panel.closest('.product-info-secondary') || panel.parentElement;
      scope?.addEventListener('click', (event) => {
        const target = event.target.closest?.('[data-atlas-action="open-personaliser"]');
        if (target) track('atlas_create_stamp_click', metadata);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
